/* ORGANIC IQ · comportamiento de las páginas de tienda
   © Ratispa · Construido con el Método Ratispa · PARM
   Encabezado que reaparece al subir, menú, galería, opciones de compra, barra fija,
   botón de subir y carruseles. Sin dependencias. Funciona con el scroll de la ventana
   o con el contenedor .page-wrapper del tema base. */
(function () {
  'use strict';

  var pw = function () { return document.querySelector('.page-wrapper'); };
  function scroller() {
    var el = pw();
    if (el && el.scrollHeight > el.clientHeight + 2) {
      var oy = getComputedStyle(el).overflowY;
      if (oy === 'auto' || oy === 'scroll') return el;
    }
    return null;
  }
  function scrollY() {
    var el = scroller();
    return el ? el.scrollTop : (window.scrollY || document.documentElement.scrollTop || 0);
  }
  function onScroll(fn) {
    var pendiente = false;
    function h() {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () { pendiente = false; fn(); });
    }
    window.addEventListener('scroll', h, { passive: true });
    var el = pw();
    if (el) el.addEventListener('scroll', h, { passive: true });
    fn();
  }

  /* encabezado: se queda arriba y reaparece al subir */
  function encabezado() {
    var wrap = document.querySelector('[data-oiq-headwrap]');
    if (!wrap || wrap.dataset.oiqListo) return;
    wrap.dataset.oiqListo = '1';
    var head = wrap.querySelector('[data-oiq-head]');
    if (!head) return;
    function medir() { wrap.style.minHeight = head.offsetHeight + 'px'; }
    medir();
    window.addEventListener('resize', medir);
    var ultimo = scrollY();
    onScroll(function () {
      var y = scrollY();
      var fuera = wrap.getBoundingClientRect().bottom < 0;
      var menuAbierto = head.querySelector('details[open]');
      if (!fuera) {
        head.classList.remove('flota', 'vis');
      } else {
        head.classList.add('flota');
        if (menuAbierto || y < ultimo - 4) head.classList.add('vis');
        else if (y > ultimo + 4) head.classList.remove('vis');
      }
      ultimo = y;
    });
  }

  /* menú lateral */
  function menu() {
    document.querySelectorAll('[data-oiq-menu]').forEach(function (d) {
      if (d.dataset.oiqListo) return;
      d.dataset.oiqListo = '1';
      d.querySelectorAll('[data-oiq-menu-cerrar], .oiq-menu__panel a').forEach(function (el) {
        el.addEventListener('click', function () { d.open = false; });
      });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { d.open = false; d.querySelector('summary').focus(); } });
    });
  }

  /* galería con miniaturas y flechas */
  function galeria(raiz) {
    var track = raiz.querySelector('[data-oiq-track]');
    if (!track || track.dataset.oiqListo) return;
    track.dataset.oiqListo = '1';
    var slides = Array.prototype.slice.call(track.children);
    var minis = Array.prototype.slice.call(raiz.querySelectorAll('[data-oiq-mini]'));
    var tira = raiz.querySelector('.oiq-gal__mini');
    var actual = 0;
    function marcar(n) {
      actual = n;
      minis.forEach(function (b, k) { b.setAttribute('aria-current', k === n ? 'true' : 'false'); });
      var m = minis[n];
      if (m && tira) {
        var izq = m.offsetLeft - tira.offsetLeft, der = izq + m.offsetWidth;
        if (izq < tira.scrollLeft || der > tira.scrollLeft + tira.clientWidth) tira.scrollTo({ left: izq - 8, behavior: 'smooth' });
      }
    }
    function ir(n) {
      if (!slides.length) return;
      n = (n + slides.length) % slides.length;
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
      marcar(n);
    }
    var pendiente = false;
    track.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        var n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (n !== actual) marcar(Math.min(slides.length - 1, Math.max(0, n)));
      });
    }, { passive: true });
    minis.forEach(function (b, k) { b.addEventListener('click', function () { ir(k); }); });
    raiz.querySelectorAll('[data-oiq-izq]').forEach(function (b) { b.addEventListener('click', function () { ir(actual - 1); }); });
    raiz.querySelectorAll('[data-oiq-der]').forEach(function (b) { b.addEventListener('click', function () { ir(actual + 1); }); });
    marcar(0);
  }

  /* opciones de compra: cambia la variante de todos los botones */
  function oferta() {
    document.querySelectorAll('[data-oiq-oferta]').forEach(function (box) {
      if (box.dataset.oiqListo) return;
      box.dataset.oiqListo = '1';
      box.addEventListener('change', function (e) {
        var inp = e.target;
        if (!inp || inp.type !== 'radio') return;
        box.querySelectorAll('.oiq-of__c').forEach(function (c) { c.classList.toggle('on', c.contains(inp)); });
        document.querySelectorAll('[data-oiq-buy]').forEach(function (a) {
          a.href = (a.dataset.cart || '/cart') + '/' + inp.value + ':1' + (a.dataset.desc || '');
        });
      });
    });
  }

  /* barra fija de compra + botón de subir */
  function barraFija() {
    var barra = document.querySelector('[data-oiq-fija]');
    var arriba = document.querySelector('[data-oiq-arriba]');
    var cta = document.querySelector('[data-oiq-cta]');
    if (!cta || (!barra && !arriba)) return;
    if (cta.dataset.oiqListo) return;
    cta.dataset.oiqListo = '1';
    var fin = document.querySelectorAll('[data-oiq-fin]');
    var pasado = false, finVisible = false;
    function pintar() {
      var on = pasado && !finVisible;
      if (barra) { barra.classList.toggle('on', on); barra.setAttribute('aria-hidden', on ? 'false' : 'true'); }
      if (arriba) arriba.classList.toggle('on', pasado);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        pasado = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
        pintar();
      }).observe(cta);
      if (fin.length) {
        var vistos = new Set();
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) vistos.add(e.target); else vistos.delete(e.target); });
          finVisible = vistos.size > 0;
          pintar();
        });
        fin.forEach(function (el) { io.observe(el); });
      }
    }
    if (arriba) arriba.addEventListener('click', function () {
      var el = scroller();
      (el || window).scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* botones que llevan a un bloque de la misma página (sin cambiar la URL) */
  function saltos() {
    document.querySelectorAll('[data-oiq-ir]').forEach(function (b) {
      if (b.dataset.oiqListo) return;
      b.dataset.oiqListo = '1';
      b.addEventListener('click', function (e) {
        var t = document.getElementById(b.dataset.oiqIr);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var inp = t.querySelector('input[type=email]');
        if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, 450);
      });
    });
  }

  /* carruseles con puntos */
  function carrusel(raiz) {
    if (raiz.dataset.oiqListo) return;
    raiz.dataset.oiqListo = '1';
    var track = raiz.querySelector('[data-oiq-car-track]');
    var puntos = Array.prototype.slice.call(raiz.querySelectorAll('[data-oiq-car-punto]'));
    if (!track) return;
    var n = track.children.length, actual = 0, tocado = 0;
    function marcar(k) { actual = k; puntos.forEach(function (p, i) { p.setAttribute('aria-current', i === k ? 'true' : 'false'); }); }
    function ir(k) {
      k = (k + n) % n;
      var s = track.children[k];
      if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      marcar(k);
    }
    track.addEventListener('scroll', function () {
      var k = Math.round(track.scrollLeft / Math.max(1, track.children[0] ? track.children[0].offsetWidth : track.clientWidth));
      if (k !== actual) marcar(Math.min(n - 1, Math.max(0, k)));
    }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, function () { tocado = Date.now(); }, { passive: true }); });
    puntos.forEach(function (p, i) { p.addEventListener('click', function () { tocado = Date.now(); ir(i); }); });
    marcar(0);
    var ms = parseInt(raiz.dataset.oiqAuto || '0', 10);
    var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (ms > 0 && n > 1 && !quieto) {
      setInterval(function () {
        if (document.hidden || Date.now() - tocado < 8000) return;
        var r = track.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        ir(actual + 1);
      }, ms);
    }
  }

  function iniciar() {
    encabezado();
    menu();
    document.querySelectorAll('[data-oiq-gal]').forEach(galeria);
    oferta();
    barraFija();
    saltos();
    document.querySelectorAll('[data-oiq-car]').forEach(carrusel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
